var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type == "Polygon")?_c('PolygonGeometry',_vm._g(_vm._b({attrs:{"geometry":_vm.geojson}},'PolygonGeometry',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }